import { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Row, Col, Modal } from "react-bootstrap";
import "./activate-procountor.css";
import { activateProcountor } from "./api";
import { Button } from "./common/Button.tsx";

export function ActivateProcountor({ show = true, onClose }) {
  const [step, setStep] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      mainUserName: "",
      mainUserEmail: "",
    },
  });

  const nextStep = (values) => {
    if (step < 2) return setStep(step + 1);
    console.log("SUBMIT", values); // call API here
  };

  return (
    <Modal show={show} onHide={onClose} dialogClassName="hr-wizard-modal" size="xl" centered>
      <div className="wizard-container">
        <div className="wizard-header">
          <span className="wizard-title">HR User</span>
          <span className="wizard-step">Step {step} / 2</span>
        </div>
        <progress style={{ width: "100%" }} value={step} max="2"></progress>

        <Form onSubmit={handleSubmit(nextStep)} className="wizard-body">
          {/* STEP 1 */}
          {step === 1 && (
            <Row>
              {/* LEFT */}
              <Col className="wizard-left">
                <h3 className="wizard-heading">Who will be your main user?</h3>
                <p className="wizard-subtext">Great to have you, let's proceed to create the main user for HR.</p>

                <div className="notice-box">
                  <div className="notice-icon">⚠️</div>
                  <div>
                    The main user will have <strong>full access</strong> to all information in the HR system. This
                    includes salary data, personal details, and other records.
                  </div>
                </div>

                <Button testId="continue" variant="primary" type="submit" className="wizard-primary-btn mt-3">
                  Continue
                </Button>
              </Col>

              {/* RIGHT */}
              <Col className="wizard-right">
                <img src="/procountor-activation-1.svg" alt="" className="wizard-image" />
                <p className="wizard-description">
                  We will seamlessly import and pre-fill your company HR data. Once you choose the main user, we'll ask
                  for their name and email and send them an invitation.
                </p>
              </Col>
            </Row>
          )}

          {/* STEP 2 (example form) */}
          {step === 2 && (
            <Row>
              <Col className="wizard-left">
                <Form.Group>
                  <Form.Label>Main User Full Name</Form.Label>
                  <Form.Control {...register("mainUserName", { required: true })} />
                  {errors.mainUserName && <div className="error-text">Required</div>}
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label>Main User Email</Form.Label>
                  <Form.Control type="email" {...register("mainUserEmail", { required: true })} />
                  {errors.mainUserEmail && <div className="error-text">Required</div>}
                </Form.Group>

                <div className="wizard-footer">
                  <Button testId="back" variant="outline-secondary" onClick={() => setStep(1)}>
                    Back
                  </Button>
                  <Button
                    testId="submit"
                    type="submit"
                    className="wizard-primary-btn"
                    onClick={() => activateProcountor(129)}
                    variant="primary"
                  >
                    Finish
                  </Button>
                </div>
              </Col>
              <Col className="wizard-right">
                <img
                  src="/procountor-activation-2.svg"
                  alt=""
                  className="wizard-image"
                  style={{ width: "50%", display: "block", margin: "0 auto 2rem" }}
                />
                <p className="wizard-description">
                  We will seamlessly import and pre-fill your company HR data. Once you choose the main user, we'll ask
                  for their name and email and send them an invitation.
                </p>
              </Col>
            </Row>
          )}
        </Form>

        <Modal.Footer className="wizard-bottom" style={{ justifyContent: "left" }}>
          <Button testId="cancel" variant="light" onClick={onClose} className="cancel-btn">
            Cancel
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
